<template lang="pug">
- const MAX_FILTERS_FOR_DUMP = 10
- const channels = [
- {name: 'r', color: '#f55'}, 
- {name: 'g', color: '#5f5'},
- {name: 'b', color: '#55f'},
- ]
div
  template(v-if=`filters.length >= ${MAX_FILTERS_FOR_DUMP}`)
    tbody
      each ch, i in channels
        tr
          th(style={ color: ch.color })
            = ch.name
          th
            select(v-model=`_${ch.name}`)
              option(v-for="f in filters", :value="f.value") {{ f.short }}
      th
        each ch, i in channels
          span(style={ color: ch.color })= ch.name
      td
        select(v-model="singleFilterSelect")
          option(:value="null") Select one
          option(:disabled="true") -
          option(v-for="f in filters", :value="f.value") {{ f.short }}
  template(v-else)
    table
      thead
        tr
          th
          th(v-for="(f, i) in filters")
            button(@click="singleFilter(f.value)") {{ f.short }}
      tbody
        each ch, i in channels
          tr
            th(style={ color: ch.color })= ch.name
            td(v-for="(f, i) in filters")
              input(type="radio", v-model=`_${ch.name}`, :value="f.value")
//-
  <filter-selector
    r.sync="HSC-I"
    g.sync="HSC-r"
    b.sync="HSC-g"
    :filters="[{value: 'HSC-I', short: 'i'}, {value: 'HSC-r', 'g', ...}]" />
</template>


<script lang="ts">
import { Component, Vue, Prop, Watch } from "vue-property-decorator"

@Component
export default class extends Vue {
  @Prop({ default: () => [] })
  filters!: Array<{ value: string; short: string }>

  @Prop({ required: true })
  r!: string

  get _r() {
    return this.r
  }
  set _r(v: string) {
    this.$emit("update:r", v)
  }

  @Prop({ required: true })
  g!: string
  get _g() {
    return this.g
  }
  set _g(v: string) {
    this.$emit("update:g", v)
  }

  @Prop({ required: true })
  b!: string
  get _b() {
    return this.b
  }
  set _b(v: string) {
    this.$emit("update:b", v)
  }

  singleFilterSelect = null as null | string
  @Watch("singleFilterSelect")
  onSingleFilterSelectChange() {
    if (this.singleFilterSelect) {
      this.singleFilter(this.singleFilterSelect)
    }
    this.singleFilterSelect = null
  }

  singleFilter(filter: string) {
    this.$emit("update:r", filter)
    this.$emit("update:g", filter)
    this.$emit("update:b", filter)
  }
}
</script>


<style lang="scss" scoped>
table {
  border-collapse: collapse;
}
td,
th {
  border: 1px #333 solid;
  text-align: center;
  padding: 2px 0;
  min-width: 2em;
}
</style>
